<template>
  <div class="ebsn-3d-viewer-btn-toggle pa-2">
    <div class="d-flex justify-space-between">
      <h4>{{ conf.productOptGroup.name }}</h4>
      <v-btn icon @click="emitClose">x</v-btn>
    </div>
    <v-btn-toggle outlined v-model="internalValue" @change="emitChange">
      <v-btn
        v-for="option in conf.productOpts"
        :key="option.productProductOptId"
        :value="option.productOpt.productOptId"
        size="large"
        class="d-flex justify-space-between"
      >
        <span class="option-descr">
          {{ option.productOpt.description }}
        </span>
        <v-icon small>$plus</v-icon>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  props: {
    conf: { type: Object, required: true },
    modelValue: [String, Number, null]
  },
  data() {
    return {
      internalValue: this.modelValue
    };
  },
  watch: {
    modelValue(val) {
      this.internalValue = val;
    }
  },
  methods: {
    emitChange() {
      this.$emit("update:modelValue", this.internalValue);
    },
    emitClose() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss">
.ebsn-3d-viewer-btn-toggle {
  display: flex;
  flex-direction: column;
  .v-item-group.v-btn-toggle {
    // display: block;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    .v-btn {
      height: auto;
      border-width: 1px !important;
      border-radius: 4px;
      width: 100%;
      max-width: 100%;
      padding: 5px 12px;
      background-color: white;
      justify-content: flex-start;

      &.selected {
        border: 2px solid var(--v-primary-base) !important;
      }
      .v-btn__content {
        .option-descr {
          color: var(--v-default-base);
          text-decoration: none;
          text-transform: none;
          font-size: 13px;
          line-height: 18px;
          font-weight: 400;
          letter-spacing: 0px;
          display: inline-block;
          white-space: normal;
          text-align: center;
          margin-top: 6px;
          margin-bottom: 6px;
        }
      }
    }
  }
  .v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
    border-color: var(--v-grey-darken1) !important;
  }
}
</style>
